import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Briefcase, Users2, Landmark, Shield, Crown } from 'lucide-react';
export function PlatformApplications() {
  const applications = [{
    icon: <GraduationCap size={24} data-id="element-287" />,
    title: 'Education Systems',
    desc: 'Support reasoning, emotional regulation, media literacy, and long-range capability-building from early childhood through university.'
  }, {
    icon: <Briefcase size={24} data-id="element-288" />,
    title: 'Employers and Workforce Programs',
    desc: 'Improve execution, communication, advancement readiness, decision quality, and leadership development across teams and organizations.'
  }, {
    icon: <Users2 size={24} data-id="element-289" />,
    title: 'Civil Society',
    desc: 'Strengthen mentorship networks, local resilience, civic participation, and opportunity alignment at the community level.'
  }, {
    icon: <Landmark size={24} data-id="element-290" />,
    title: 'Government and Public Institutions',
    desc: 'Support public-sector modernization, workforce planning, capability mapping, leadership preparation, and institutional strengthening.'
  }, {
    icon: <Shield size={24} data-id="element-291" />,
    title: 'Civil Service',
    desc: 'Improve readiness for roles that demand integrity, systems thinking, stability under pressure, and responsibility at scale.'
  }, {
    icon: <Crown size={24} data-id="element-292" />,
    title: 'Executive Leadership Environments',
    desc: 'Provide a more rigorous framework for evaluating readiness in high-responsibility roles where poor judgment can create broad institutional or national consequences.'
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-surface-bg border-t border-line" data-id="element-293">
      <div className="mb-16" data-id="element-294">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-295">
          Applications
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-296">
          Built for individuals, institutions, and nations
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-297">
        {applications.map((app, index) => <motion.div key={app.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-white p-8 rounded-lg border border-line shadow-sm hover:shadow-md transition-all group" data-id="element-298">
            <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-navy-light mb-6 group-hover:bg-navy group-hover:text-white transition-colors" data-id="element-299">
              {app.icon}
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-300">
              {app.title}
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-301">{app.desc}</p>
          </motion.div>)}
      </div>
    </section>;
}